import React, { Component } from 'react';
import { fileKey } from '../../../../../../util/file_url'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import AudioPreview from './AudioPreview'
import VideoPreview from './VideoPreview'
import ImagePreview from './ImagePreview'
import ModelPreview from './ModelPreview'
import ColorTexturePickerPreview from './ColorTexturePickerPreview'
import PDFPreview from './PDFPreview'
import {isAudio, isVideo, isDocument, isImage, isModel} from '../../../../../Templates/functions'
import {findExtension} from '../../../../../Templates/functions'
export default class FilePreview extends Component {
    render() {
        let ext = findExtension(this.props.file.path)
        
        if(isAudio(ext)) {
            return <AudioPreview file={this.props.file} filename={fileKey(this.props.file)} return={this.props.return}/>
        } else if (isVideo(ext)){
            return <VideoPreview file={this.props.file} filename={fileKey(this.props.file)} return={this.props.return}/>
        } else if (isImage(ext)) {
            return <ImagePreview file={this.props.file} filename={fileKey(this.props.file)} return={this.props.return}/>
        } else if (isDocument(ext)) {
            return <PDFPreview file={this.props.file} filename={fileKey(this.props.file)} return={this.props.return}/>
        } else if (isModel(ext)) {
            if (this.props.isColorTexturePicker) {
                return <ColorTexturePickerPreview 
                    model={this.props.file} 
                    return={this.props.return}
                    selectedTextureIndex={this.props.selectedTextureIndex}
                    textures={this.props.textures}
                    onTextureSelect={this.props.onTextureSelect}
                    clearTextureSelection={this.props.clearTextureSelection}
                    onTexturesSaved={this.props.onTexturesSaved}
                />
            } else {
                return <ModelPreview model={this.props.file} return={this.props.return}/>
            }
        } else {
            console.error('FilePreview: No matching file type handler found for extension:', ext);
            return <div>Unsupported file type: {ext}</div>
        }
    }
};